module.exports = "/_next/static/images/og-image-242e3a267160826e12b26c88132b6243.jpg";